import React, {createRef} from "react";
import DocumentMenuItems from './document-menu-items-view';
import {uimanager} from "../../ui-manager";

export default class DocumentDetailsMenu extends React.Component {
  constructor() {
    super();

    this.el = createRef();
  }

  render() {
    return (
      <>
        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{
          minWidth: '40px',
          marginLeft: '5px'
        }}>
          <span className="hidden-xs">Verwalten </span><span className="caret"/>
        </button>
        <ul className="dropdown-menu dropdown-menu-right" ref={this.el}>
          <DocumentMenuItems {...this.props}/>
        </ul>
      </>
    );
  }

  componentDidMount() {
    const el = this.el.current;
    if (el) {
      uimanager.process(el);
    }
  }
}
